'use client';
import { use, useState, useEffect, useMemo, useCallback } from 'react';
import { HeaderUIStateContext } from '@/components/header/header_menu/HeaderUIStateProvider';
import Cookies from 'js-cookie';
import DiscountBanner from '../discount_banner/DiscountBanner';

function HeaderWrapper({ children }) {
  const { showUtility, isHomePage, navHoverItem } = use(HeaderUIStateContext);

  const [showDiscountBanner, setShowDiscountBanner] = useState(false);
  const [showBorder, setShowBorder] = useState(false);
  const discountBannerInterval = 7000;

  const displayDiscountBanner = useCallback(() => {
    setShowDiscountBanner(true);
    setTimeout(() => setShowDiscountBanner(false), discountBannerInterval);
  }, []);

  // Check for the 'cupc' query parameter and handle the discount banner
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const cupc = params.get('cupc');

    if (cupc) {
      Cookies.set('lsa-cupc', cupc);
      displayDiscountBanner();
    }
  }, [displayDiscountBanner]);

  // Determine if the header should show a border
  useEffect(() => {
    setShowBorder(!isHomePage || navHoverItem);
  }, [isHomePage, navHoverItem]);

  // Memoized class names for the header
  const headerClasses = useMemo(
    () =>
      `h-15 w-screen bg-white fixed text-default font-medium top-[48px] left-0 z-50 border-b transform transition-transform duration-300
      ${showUtility ? 'translate-y-0' : '-translate-y-[49px]'}
      ${showBorder ? 'border-dawn-grey-30' : 'border-white'}`,
    [showUtility, showBorder]
  );

  return (
    <>
      {showDiscountBanner && (
        <DiscountBanner setShowDiscountBanner={setShowDiscountBanner} />
      )}
      <div className={headerClasses}>
        <div className="mx-auto h-15 justify-center px-4 lg:max-w-[1536px] lg:px-20 2xl:max-w-[1680px]">
          <div className="flex h-15 w-full items-center justify-between">
            {children}
          </div>
        </div>
      </div>
    </>
  );
}

export default HeaderWrapper;
